import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sprout } from "lucide-react";
import api from "../lib/api";

function isExternal(url) { return /^https?:\/\//i.test(url || ""); }
function ItemLink({ item }) {
  if (!item.url) return <span>{item.label}</span>;
  if (isExternal(item.url)) {
    return <a href={item.url} target="_blank" rel="noopener noreferrer" className="hover:underline">{item.label}</a>;
  }
  return <Link to={item.url} className="hover:underline">{item.label}</Link>;
}

const DEFAULTS = {
  brand_name: "Cela Seguro",
  description: "A comunidade brasileira que indica lugares seguros para celíacos, intolerantes à lactose e veganos comerem com tranquilidade.",
  col1_title: "Comunidade",
  col1_items: [
    { label: "Cadastre um lugar seguro", url: "/cadastrar-lugar" },
    { label: "Compartilhe sua experiência", url: "/explorar" },
    { label: "Ajude a moderação", url: "/moderacao" },
  ],
  col2_title: "Sobre",
  col2_text: "Avaliações verificadas por moderadores antes de aparecerem no site, garantindo informação confiável para quem tem restrição alimentar.",
  copyright: "© {year} Cela Seguro · Feito com cuidado por e para a comunidade.",
  bg_color: "#1C2321",
  text_color: "#FDFBF7",
  accent_color: "#E87C55",
};

export default function Footer() {
  const [cfg, setCfg] = useState(DEFAULTS);

  useEffect(() => {
    api.get("/footer").then((r) => {
      if (r.data && Object.keys(r.data).length > 0) {
        setCfg({ ...DEFAULTS, ...r.data });
      }
    }).catch(() => {});
  }, []);

  const year = new Date().getFullYear();
  const copyright = (cfg.copyright || DEFAULTS.copyright).replace("{year}", year);
  const textDim = `${cfg.text_color}b3`;
  const textFaint = `${cfg.text_color}99`;
  const border = `${cfg.text_color}1a`;

  return (
    <footer data-testid="site-footer" className="mt-24" style={{ background: cfg.bg_color, color: cfg.text_color }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <span className="w-10 h-10 rounded-2xl flex items-center justify-center" style={{ background: cfg.accent_color, color: "#fff" }}><Sprout className="w-5 h-5" /></span>
            <span className="font-heading font-black text-xl">{cfg.brand_name}</span>
          </div>
          <p className="text-sm leading-relaxed max-w-sm" style={{ color: textDim }}>{cfg.description}</p>
        </div>
        <div>
          <h4 className="font-heading font-bold uppercase tracking-[0.15em] text-xs mb-4" style={{ color: textFaint }}>{cfg.col1_title}</h4>
          <ul className="space-y-2 text-sm" style={{ color: textDim }}>
            {(cfg.col1_items || []).map((it, i) => (
              <li key={`footer-item-${i}-${it.label}`}><ItemLink item={it} /></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-heading font-bold uppercase tracking-[0.15em] text-xs mb-4" style={{ color: textFaint }}>{cfg.col2_title}</h4>
          <p className="text-sm leading-relaxed" style={{ color: textDim }}>{cfg.col2_text}</p>
        </div>
      </div>
      <div className="border-t py-6 text-center text-xs" style={{ borderColor: border, color: textFaint }}>
        {copyright}
      </div>
    </footer>
  );
}
